import {
  ACCOUNTING_INVOICES_PAGE_PATH,
  NEW_INVOICING_PAGE_PATH,
  ACCOUNTING_INVOICE_SETTINGS_PAGE_PATH,
  ACCOUNTING_REPORT_PAGE_PATH,
  INVOICE_LOGS_PAGE_PATH,
  ACCOUNTS_PAGE_PATH,
  ADMINLOGS_PAGE_PATH,
  APIKEYS_PAGE_PATH,
  BGERROR_GALLERY_PAGE_PATH,
  BODYSTYLES_PAGE_PATH,
  COMPARISION_PAGE_PATH,
  CONFIRMVDS_GALLERY_PAGE_PATH,
  CRONSTATS_PAGE_PATH,
  DASHBOARD_PAGE_PATH,
  DEALERLOG_PAGE_PATH,
  DEALERPROFILE_PAGE_PATH,
  DEFAULT_GUIDES_PAGE_PATH,
  EDITORPROFILE_PAGE_PATH,
  EDITOR_REPORT_PAGE_PATH,
  EDITTRACKER_PAGE_PATH,
  EXPORT_ORDER_PAGE_PATH,
  EXPORT_PAGE_PATH,
  FEATURE_BANNERS_PAGE_PATH,
  FEATURE_BANNERS_SETTINGS_PAGE_PATH,
  FAQ_PATH,
  EXPORT_DMS_PATH,
  IMPORT_DMS_PATH,
  ANNOUNCEMENT_BANNER_PAGE_PATH,
  AUTOPORT_SETTINGS_PAGE_PATH,
  PROMO_BANNER_FAQ_PATH,
  FEATURE_ICONS_PAGE_PATH,
  FILEMANAGER_PAGE_PATH,
  FLAGS_PAGE_PATH,
  IMPORT_PAGE_PATH,
  INTEGRATION_PAGE_PATH,
  INVENTORY_DETAILS_PAGE_PATH,
  INVENTORY_PAGE_PATH,
  INVOICING_PAGE_PATH,
  MASTER_COMPOSITIONS_PAGE_PATH,
  MAVIS_GALLERY_PAGE_PATH,
  MAVIS_PAGE_PATH,
  MAVIS_PRESENTS_PAGE_PATH,
  MAVIS_SETTINGS_PAGE_PATH,
  NOTIFICATIONS_PAGE_PATH,
  OURMISSION_PAGE_PATH,
  PAGUIDES_PAGE_PATH,
  PHOTOGRAPHER_PROFILE_PAGE_PATH,
  PHOTON360_VIEWER_PAGE_PATH,
  QUALITY_CONTROL_EDITFLAGS_PAGE_PATH,
  QUALITY_CONTROL_PAGE_PATH,
  REPORTSETTINGS_PAGE_PATH,
  RETRO_OPERATIONS_PATH,
  SALES_PAGE_PATH,
  TEAMPROFILE_PAGE_PATH,
  THEME_DOCS_PAGE_PATH,
  USERPROFILE_PAGE_PATH,
  VEHICLE_GALLERY_PAGE_PATH,
  VIDEOGENERATION_PAGE_PATH,
  YOUTUBE_THUMBNAIL_PAGE_PATH,
  VIDEO_PAGE_PATH,
  PROMO_BANNERS_PAGE_PATH,
  PROMO_BILLBOARDS_PAGE_PATH,
  REPORT_STATISTICS_PATH,
  USER_ROLES_PATH,
  PHOTOGRAPHERS_ACCOUNTS_PAGE_PATH,
  VIN_STATUS_TRACKER,
  LSP_RATE_PATH,
  DEVELOPER_ACCESS_PAGE_PATH,
  INSTA360_PAGE_PATH,
  EXT360_PAGE_PATH,
  LSP_INVOICES_PATH,
  RATIO_SETTINGS_PAGE_PATH,
  WINDOW_STICKER_DASHBOARD_PATH,
  WINDOW_STICKER_PRICING_PATH,
  VIN_TURNAROUND_PAGE_PATH
} from '../constants/appPathConst';

export const getTitleOfPage = (defaultPath = '') => {
  const DEFAULTPAGE = 'Dashboard';

  const originalPageTitles = {
    [DASHBOARD_PAGE_PATH]: DEFAULTPAGE,
    [COMPARISION_PAGE_PATH]: 'Dealer Comparison',
    [EDITTRACKER_PAGE_PATH]: 'Edit Tracker',
    [MAVIS_PAGE_PATH]: 'MAVIS™',
    [EXPORT_PAGE_PATH]: 'Export',
    [IMPORT_PAGE_PATH]: 'Import',
    [INVENTORY_PAGE_PATH]: 'Inventory',
    [INVENTORY_DETAILS_PAGE_PATH]: 'Inventory Details',
    [DEALERPROFILE_PAGE_PATH]: 'Dealer Profile',
    [PHOTOGRAPHER_PROFILE_PAGE_PATH]: 'Profiles',
    [ACCOUNTS_PAGE_PATH]: 'Accounts',
    [QUALITY_CONTROL_PAGE_PATH]: 'Quality Control',
    [QUALITY_CONTROL_EDITFLAGS_PAGE_PATH]: 'Edits & Flags',
    [VIDEO_PAGE_PATH]: 'Video',
    [INSTA360_PAGE_PATH]: 'Interior 360',
    [EXT360_PAGE_PATH]: 'Exterior 360',
    [FILEMANAGER_PAGE_PATH]: 'File Manager',
    [PAGUIDES_PAGE_PATH]: 'PA Guides Order',
    [EXPORT_ORDER_PAGE_PATH]: 'Export Order',
    [MAVIS_SETTINGS_PAGE_PATH]: 'MAVIS™',
    [RATIO_SETTINGS_PAGE_PATH]: 'Ratio Settings',
    [MASTER_COMPOSITIONS_PAGE_PATH]: 'Master Compositions',
    [DEFAULT_GUIDES_PAGE_PATH]: 'Default Guides',
    [MAVIS_PRESENTS_PAGE_PATH]: 'MAVIS™ Presets',
    [FEATURE_ICONS_PAGE_PATH]: 'Feature Icons',
    [FLAGS_PAGE_PATH]: 'Flags',
    [BODYSTYLES_PAGE_PATH]: 'Body Styles',
    [APIKEYS_PAGE_PATH]: 'API Key',
    [VIDEOGENERATION_PAGE_PATH]: 'Video Generation',
    [YOUTUBE_THUMBNAIL_PAGE_PATH]: 'YouTube Thumbnail',
    [PROMO_BANNERS_PAGE_PATH]: 'Promo Banners',
    [PROMO_BILLBOARDS_PAGE_PATH]: 'Promo Billboards',
    [FEATURE_BANNERS_PAGE_PATH]: 'Feature Banners',
    [FEATURE_BANNERS_SETTINGS_PAGE_PATH]: 'Feature Banners Library',
    [REPORTSETTINGS_PAGE_PATH]: 'Report Settings',
    [REPORT_STATISTICS_PATH]: 'Report Statistics',
    [INVOICING_PAGE_PATH]: 'Invoicing',
    [ACCOUNTING_INVOICES_PAGE_PATH]: 'Invoices',
    [NEW_INVOICING_PAGE_PATH]: 'Autoport Invoices',
    [ACCOUNTING_REPORT_PAGE_PATH]: 'Download Reports',
    [ACCOUNTING_INVOICE_SETTINGS_PAGE_PATH]: 'Invoice Settings',
    [INVOICE_LOGS_PAGE_PATH]: 'Invoice Logs',
    [EDITOR_REPORT_PAGE_PATH]: 'Editor Avg. Time Reports',
    [ADMINLOGS_PAGE_PATH]: 'Admin Logs',
    [SALES_PAGE_PATH]: 'Sales',
    [DEALERLOG_PAGE_PATH]: 'Dealer Logs',
    [CRONSTATS_PAGE_PATH]: 'CRONs Statistics',
    [OURMISSION_PAGE_PATH]: 'Mission Statement and Guiding Principles',
    [NOTIFICATIONS_PAGE_PATH]: 'Notifications',
    [USERPROFILE_PAGE_PATH]: 'User Profile',
    [EDITORPROFILE_PAGE_PATH]: 'My Profile',
    [INTEGRATION_PAGE_PATH]: 'Social Media Integration',
    [TEAMPROFILE_PAGE_PATH]: 'Team Profile',
    [VEHICLE_GALLERY_PAGE_PATH]: 'Vehicle Display',
    [BGERROR_GALLERY_PAGE_PATH]: 'BG Error',
    [MAVIS_GALLERY_PAGE_PATH]: 'Mavis Vehicle',
    [CONFIRMVDS_GALLERY_PAGE_PATH]: 'Confirm VDS',
    [PHOTON360_VIEWER_PAGE_PATH]: 'Media Viewer',
    [DEVELOPER_ACCESS_PAGE_PATH]: 'Developer Access',
    [THEME_DOCS_PAGE_PATH]: 'Theme Docs',
    [RETRO_OPERATIONS_PATH]: 'Retro Operations',
    [FAQ_PATH]: 'PA Settings',
    [USER_ROLES_PATH]: 'User Roles',
    [EXPORT_DMS_PATH]: 'Export IMS',
    [IMPORT_DMS_PATH]: 'Import IMS',
    [PHOTOGRAPHERS_ACCOUNTS_PAGE_PATH]: 'Accounts Creation',
    [ANNOUNCEMENT_BANNER_PAGE_PATH]: 'Manage Announcements',
    [AUTOPORT_SETTINGS_PAGE_PATH]: 'Autoport Settings',
    [PROMO_BANNER_FAQ_PATH]: 'Promo Banners FAQ',
    [VIN_STATUS_TRACKER]: 'VIN Status Tracker',
    [LSP_RATE_PATH]: 'Invoicing Settings',
    [LSP_INVOICES_PATH]: 'Invoices',
    [WINDOW_STICKER_DASHBOARD_PATH]: 'Window Sticker Dashboard',
    [WINDOW_STICKER_PRICING_PATH]: 'Window Sticker Pricing',
    [VIN_TURNAROUND_PAGE_PATH]: 'VIN Turnaround'
  };

  const pageTitles = Object.keys(originalPageTitles)?.reduce((acc, key) => {
    acc[key?.toLowerCase()] = originalPageTitles[key];
    return acc;
  }, {});

  const normalizedPath = defaultPath?.toLowerCase();
  return pageTitles[normalizedPath] || DEFAULTPAGE;
};

export function generateBreadcrumbs(defaultPath) {
  const defaultPage = [{ name: 'Dashboard', path: DASHBOARD_PAGE_PATH, active: 'true' }];

  const pageName = getTitleOfPage(defaultPath);

  let breadcrumbs;
  switch (defaultPath) {
    case DASHBOARD_PAGE_PATH:
      breadcrumbs = defaultPage;
      break;

    case COMPARISION_PAGE_PATH:
    case EDITTRACKER_PAGE_PATH:
    case MAVIS_PAGE_PATH:
    case EXPORT_PAGE_PATH:
    case IMPORT_PAGE_PATH:
    case DEALERPROFILE_PAGE_PATH:
    case PHOTOGRAPHER_PROFILE_PAGE_PATH:
    case QUALITY_CONTROL_PAGE_PATH:
    case QUALITY_CONTROL_EDITFLAGS_PAGE_PATH:
    case VIDEO_PAGE_PATH:
    case INSTA360_PAGE_PATH:
    case EXT360_PAGE_PATH:
    case FILEMANAGER_PAGE_PATH:
    case PROMO_BANNERS_PAGE_PATH:
    case PROMO_BILLBOARDS_PAGE_PATH:
    case INVOICING_PAGE_PATH:
    case ADMINLOGS_PAGE_PATH:
    case SALES_PAGE_PATH:
    case INVENTORY_PAGE_PATH:
    case ACCOUNTS_PAGE_PATH:
    case CRONSTATS_PAGE_PATH:
    case PHOTOGRAPHERS_ACCOUNTS_PAGE_PATH:
    case VIN_STATUS_TRACKER:
    case OURMISSION_PAGE_PATH:
    case WINDOW_STICKER_DASHBOARD_PATH:
    case WINDOW_STICKER_PRICING_PATH:
    case USER_ROLES_PATH:
    case VIN_TURNAROUND_PAGE_PATH:
    case DEVELOPER_ACCESS_PAGE_PATH:
      breadcrumbs = [{ name: pageName, active: 'true' }];
      break;

    case LSP_RATE_PATH:
    case LSP_INVOICES_PATH:
      breadcrumbs = [
        { name: 'LSP', active: 'false' },
        { name: pageName, active: 'true' }
      ];
      break;

    //#region Dealer Settings
    case PAGUIDES_PAGE_PATH:
    case EXPORT_ORDER_PAGE_PATH:
    case MAVIS_SETTINGS_PAGE_PATH:
    case RATIO_SETTINGS_PAGE_PATH:
    case VIDEOGENERATION_PAGE_PATH:
    case YOUTUBE_THUMBNAIL_PAGE_PATH:
    case FEATURE_BANNERS_PAGE_PATH:
      breadcrumbs = [
        { name: 'Dealer Settings', active: 'false' },
        { name: pageName, active: 'true' }
      ];
      break;

    //#endregion

    //#region Gloabal Settings
    case FAQ_PATH:
    case EXPORT_DMS_PATH:
    case IMPORT_DMS_PATH:
    case MASTER_COMPOSITIONS_PAGE_PATH:
    case DEFAULT_GUIDES_PAGE_PATH:
    case MAVIS_PRESENTS_PAGE_PATH:
    case FEATURE_ICONS_PAGE_PATH:
    case FLAGS_PAGE_PATH:
    case BODYSTYLES_PAGE_PATH:
    case APIKEYS_PAGE_PATH:
    case REPORTSETTINGS_PAGE_PATH:
    case EDITOR_REPORT_PAGE_PATH:
    case RETRO_OPERATIONS_PATH:
    case FEATURE_BANNERS_SETTINGS_PAGE_PATH:
    case REPORT_STATISTICS_PATH:
    case AUTOPORT_SETTINGS_PAGE_PATH:
    case ANNOUNCEMENT_BANNER_PAGE_PATH:
    case PROMO_BANNER_FAQ_PATH:
      breadcrumbs = [
        { name: 'Global Settings', active: 'false' },
        { name: pageName, active: 'true' }
      ];
      break;
    //#endregion

    //#region Accounting
    case ACCOUNTING_INVOICES_PAGE_PATH:
    case NEW_INVOICING_PAGE_PATH:
    case ACCOUNTING_REPORT_PAGE_PATH:
    case ACCOUNTING_INVOICE_SETTINGS_PAGE_PATH:
    case INVOICE_LOGS_PAGE_PATH:
      breadcrumbs = [
        { name: 'Accounting', active: 'false' },
        { name: pageName, active: 'true' }
      ];
      break;
    //#endregion

    //#region Dealer Profile
    case DEALERLOG_PAGE_PATH:
      breadcrumbs = [
        {
          name: getTitleOfPage(DEALERPROFILE_PAGE_PATH),
          active: 'true',
          isLink: true,
          url: DEALERPROFILE_PAGE_PATH
        },
        { name: pageName, active: 'true' }
      ];
      break;
    //#endregion

    //#region Photographers Profile
    case USERPROFILE_PAGE_PATH:
      breadcrumbs = [
        {
          name: getTitleOfPage(PHOTOGRAPHER_PROFILE_PAGE_PATH),
          active: 'true',
          isLink: true,
          url: PHOTOGRAPHER_PROFILE_PAGE_PATH
        },
        { name: pageName, active: 'true' }
      ];
      break;
    //#endregion

    //#region Editor Profile
    case EDITORPROFILE_PAGE_PATH:
    case THEME_DOCS_PAGE_PATH:
    case INTEGRATION_PAGE_PATH:
      breadcrumbs = [
        {
          name: 'My Profile Menubar',
          active: 'false'
        },
        { name: pageName, active: 'true' }
      ];
      break;
    //#endregion

    //#region INVENTORY
    case VEHICLE_GALLERY_PAGE_PATH:
    case CONFIRMVDS_GALLERY_PAGE_PATH:
    case PHOTON360_VIEWER_PAGE_PATH:
    case INVENTORY_DETAILS_PAGE_PATH:
      breadcrumbs = [
        { name: getTitleOfPage(INVENTORY_PAGE_PATH), active: 'true', isLink: true, url: INVENTORY_PAGE_PATH },
        { name: pageName, active: 'true' }
      ];
      break;

    //#endregion

    //#region MAVIS
    case MAVIS_GALLERY_PAGE_PATH:
      breadcrumbs = [
        { name: getTitleOfPage(MAVIS_PAGE_PATH), active: 'true', isLink: true, url: MAVIS_PAGE_PATH },
        { name: pageName, active: 'true' }
      ];
      break;
    //#endregion

    //#region ACCOUNTS
    case TEAMPROFILE_PAGE_PATH:
    case NOTIFICATIONS_PAGE_PATH:
      breadcrumbs = [
        { name: getTitleOfPage(ACCOUNTS_PAGE_PATH), active: 'true', isLink: true, url: ACCOUNTS_PAGE_PATH },
        { name: pageName, active: 'true' }
      ];
      break;
    //#endregion

    default:
      breadcrumbs = defaultPage;
      break;
  }
  return breadcrumbs;
}
